const NOTIFICATION_TYPES = [
    {
      id: 1,
      name: 'Call Server',
      shortName: 'callServer',
      externalId: null
    },
    {
      id: 2,
      name: 'Survey Posted',
      shortName: 'surveyPosted',
      externalId: null
    },
    {
      id: 3,
      name: 'Card Payment',
      shortName: 'cardPayment',
      externalId: null
    },
    {
      id: 4,
      name: 'Cash Payment',
      shortName: 'cashPayment',
      externalId: null
    },
    {
      id: 5,
      name: 'Order Error',
      shortName: 'orderError',
      externalId: null
    },
    {
      id: 6,
      name: 'Payment Error',
      shortName: 'paymentError',
      externalId: null
    },
    {
      id: 7,
      name: 'Guest Check In',
      shortName: 'guestCheckIn',
      externalId: null
    },
    {
      id: 8,
      name: 'Receipt Printed',
      shortName: 'receiptPrinted',
      externalId: null
    },
    {
      id: 9,
      name: 'OrderReceived',
      shortName: 'orderReceived',
      externalId: null
    },
    {
      id: 14,
      name: 'ID Check',
      shortName: 'idCheck',
      externalId: null
    },
    {
      id: 16,
      name: 'Channel Status Update',
      shortName: null,
      externalId: null
    },
    {
      id: 18,
      name: 'Order Print',
      shortName: 'orderPrinted',
      externalId: null
    },
    {
      id: 19,
      name: 'MDM Policy Updated',
      shortName: null,
      externalId: null
    },
    {
      id: 20,
      name: 'Device Notification',
      shortName: null,
      externalId: null
    },
    {
      id: 21,
      name: 'Item Ordered',
      shortName: 'itemOrdered',
      externalId: null
    },
    {
      id: 22,
      name: 'POS Posting Error',
      shortName: 'posPostingError',
      externalId: null
    }
];

export {NOTIFICATION_TYPES}